import React from 'react';
import styled from '@emotion/styled';
import { BsViewList } from '@react-icons/all-files/bs/BsViewList';

import { decorateComponent } from '../../documentComponents';
import { Carousel } from './Carousel';
import { CarouselInspector } from './Carousel.Inspector';

export default decorateComponent(Carousel, 'block', {
  id: 'carousel',
  label: '캐로셀',
  defaultProps: {
    autoPlay: false,
    hasArrow: true,
    align: 'center',
    hasPagination: true,
    childWidthPercentage: 100,
  },
  disallowedAncestors: [
    'a',
    'coupon',
    'carousel',
    'tabButton',
  ],
  renderIcon: () => <Icon />,
  renderInspector: CarouselInspector,
});

const Icon = styled(BsViewList)`
  transform: rotate(90deg);
`;
